setTimeout(() => {
(() => {
    const TEST_ID = "MM8";
    const VARIANT_ID = "V2 ";

    function logInfo(message) {
        console.log(
        `%cAcadia%c${TEST_ID}-${VARIANT_ID}`,
        "color: white; background: rgb(0, 0, 57); font-weight: 700; padding: 2px 4px; border-radius: 2px;",
        "margin-left: 8px; color: white; background: rgb(0, 57, 57); font-weight: 700; padding: 2px 4px; border-radius: 2px;",
        message
        );
    }
    logInfo('fired');

    const isMobile = () => window.matchMedia("(max-width: 1024px)").matches;

    const selector = '.main-product-v2__badge';

    const SLEEP_SOCIAL_PROOF_HANDLES = {
        'magic-mind-welcome-sleep-melatonin': true,
        'magic-mind-welcome-sleep': true,
        'magic-mind-sleep': true,
    };

    const getProductHandle = () => {
        const match = document.body.className.match(/\bproduct--([^\s]+)/);
        return match ? match[1] : null;
    };

    const isSleepSocialProofPage = () => {
        const handle = getProductHandle();
        if (handle && SLEEP_SOCIAL_PROOF_HANDLES[handle]) {
            return true;
        }
        return document.body.classList.contains('template-preff__sleep');
    };

    const getStaticSocialProofCount = () =>
        isSleepSocialProofPage() ? 176 : null;

    const formatSocialProofLabel = (displayCount) => {
        const suffix = isSleepSocialProofPage()
            ? 'others exploring better sleep'
            : 'others exploring better focus';
        return `${displayCount} ${suffix}`;
    };

    const styles = `
        .social-proof {
            display: inline-flex;
            padding: 4px 14px;
            justify-content: center;
            align-items: center;
            gap: 10px;
            border-radius: 3px;
            background-image: url(https://cdn.shopify.com/s/files/1/0612/5086/3345/files/Background_Shadow.png?v=1767799457);
            font-size: 14px;
            font-style: normal;
            font-weight: 450;
            line-height: 24px;
            color: #000;
            text-align: center;
            text-transform: none;
        }
        @media (min-width: 1024px) {
            .social-proof {
                margin-right: 150px;
            }
        }
        @media (max-width: 1024px) {
            .main-product-v2__badge-wrapper {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
            }
            .social-proof-wrapper {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 5px;
                margin-bottom: 10px;
            }
        }
    `;

    const insertStylesOnce = (() => {
        let stylesInserted = false;

        return () => {
            if (!stylesInserted) {
                const styleElement = document.createElement('style');
                styleElement.innerHTML = styles;
                document.head.appendChild(styleElement);
                stylesInserted = true;
            }
        };
    })();

    const updateMarkup = (elementToUpdate) => {
        insertStylesOnce();

        if (window.__socialProofInProgress) {
            return;
        }

        const cleanupSocialProof = () => {
            const all = document.querySelectorAll('.social-proof-wrapper');
            if (all.length > 1) {
                all.forEach((el, idx) => {
                    if (idx !== 0) {
                        el.remove();
                    }
                });
            }
            return all[0] || null;
        };

        const existing = cleanupSocialProof();
        if (existing) {
            return;
        }

        const badgeEl = document.querySelector('.main-product-v2__badge');

        if (!badgeEl) {
            return;
        }

        const renderSocialProofBadge = (count, badgeElement) => {
            if (count === null || count < 5) {
                return;
            }

            const displayCount = count > 300 ? '300+' : String(count);
            const proofDiv = document.createElement('div');
            proofDiv.className = 'social-proof-wrapper';
            const slot = document.querySelector('.main-product-v2__social-proof-slot');
            proofDiv.innerHTML = `
                <div class="social-proof">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 13C6.6 5 17.4 5 21 13" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 17C11.606 17 11.2159 16.9224 10.8519 16.7716C10.488 16.6209 10.1573 16.3999 9.87868 16.1213C9.6001 15.8427 9.37913 15.512 9.22836 15.1481C9.0776 14.7841 9 14.394 9 14C9 13.606 9.0776 13.2159 9.22836 12.8519C9.37913 12.488 9.6001 12.1573 9.87868 11.8787C10.1573 11.6001 10.488 11.3791 10.8519 11.2284C11.2159 11.0776 11.606 11 12 11C12.7956 11 13.5587 11.3161 14.1213 11.8787C14.6839 12.4413 15 13.2044 15 14C15 14.7956 14.6839 15.5587 14.1213 16.1213C13.5587 16.6839 12.7956 17 12 17Z" fill="black" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>${formatSocialProofLabel(displayCount)}</span>
                </div>
            `;

            if (slot && !isMobile()) {
                slot.appendChild(proofDiv);
                return;
            }

            if (isMobile()) {
                const description = document.querySelector('.main-product-v2__description');
                if (description) {
                    description.insertAdjacentElement('beforebegin', proofDiv);
                }
                return;
            }

            badgeElement.insertAdjacentElement('afterend', proofDiv);
        };

        const staticCount = getStaticSocialProofCount();
        if (staticCount != null) {
            renderSocialProofBadge(staticCount, badgeEl);
            return;
        }

        const pagePath = window.location.pathname;

        if (!pagePath || pagePath === '/') {
            return;
        }

        const fetchPageViews = async () => {
            const url = `https://splittesting.acadia.io/analytics/social-proof?pid=332332205&metrics=screenPageViews&url=${encodeURIComponent(pagePath)}&startDate=1daysAgo`;

            const res = await fetch(url, { method: 'GET', credentials: 'omit' });

            if (!res.ok) {
                return null;
            }

            const data = await res.json();
            const raw = data && data.value && data.value[0] && data.value[0].screenPageViews;

            if (raw === undefined || raw === null) {
                return null;
            }

            const n = parseInt(String(raw), 10);

            return Number.isFinite(n) ? n : null;
        };

        window.__socialProofInProgress = true;

        (async () => {
            try {
                const count = await fetchPageViews();
                renderSocialProofBadge(count, badgeEl);
            } finally {
                window.__socialProofInProgress = false;
            }
        })();
    };

    const observePageURL = () => {
        let pageURL = location.href;
        const observer = new MutationObserver(() => {
            if (pageURL !== location.href) {
                pageURL = location.href;
                waitForElement(selector).then((existingElement) => {
                    if (existingElement) {
                        updateMarkup(existingElement);
                    }
                });
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    };

    const waitForElement = (selector) => {
        return new Promise((resolve) => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }
            const observer = new MutationObserver((mutations) => {
                if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
                }
            });
            observer.observe(document.body, {
                childList: true,
                subtree: true,
            });
        });
    };

    const initializeTemplate = () => {
        waitForElement(selector).then((existingElement) => {
            if (existingElement) {
                updateMarkup(existingElement);
            }
        });
        observePageURL();
    };

    initializeTemplate();
})();
}, 10);
